




























































import Vue from 'vue'
import Analytics from '@/services/Analytics'
import CloseButton from '@/components/CloseButton.vue'
import events from '@/events/events'
import User from '@/types/User.interface'
import RegistrationForm from '@/components/RegistrationForm.vue'
export default Vue.extend({
    metaInfo: {
        title: 'Sign Up and Create Your Free MessageDesk Account',
        meta: [
            {
                vmid: 'description',
                name: 'description',
                content:
                    "Start a free trial and create your free MessageDesk account. Let's start some conversations."
            }
        ]
    },
    components: { RegistrationForm, CloseButton },
    data: () => ({
        //  Styles for our elements at the foot of the page
        footerStyle: {
            position: 'absolute',
            left: 0,
            right: 0,
            margin: 'auto',
            display: 'block'
        },
        newUser: {
            email: null,
            firstname: null,
            lastname: null,
            mobilephone: null,
            organization_name: null,
            organization_type: null,
            password: null,
            selected_price: null,
            selected_company_name: null,
            terms_accepted: false
        },
        submitting: false
    }),
    mounted() {
        //  If we have an email query param then go ahead and autofill our field
        if (this.email) {
            //  Add our email to the user
            this.newUser.email = this.email
        }
    },
    computed: {
        email(): string {
            //  We need to grab the query this way because of Webflow
            const query = window.location.search

            //  If there is no query, return null
            if (!query) return null

            //  else, convert it into a param
            const param = new URLSearchParams(query)

            //  Grab our email from it
            const email = param.get('email')

            //  Return our query param
            return email
        },
        isApp(): boolean {
            return this.$store.getters.isApp
        },
        query(): string | null {
            //  IF we have the respective queries, return it
            if (this.$route.query) {
                return '?' + window.toUrlParams(this.$route.query)
            }
            return null
        },
        learningCenterLink(): string {
            return `${process.env.VUE_APP_URL_LEARN}/en/`
        },
        isColumnLayout(): boolean {
            return this.$vuetify.breakpoint.width < 820
        }
    },
    methods: {
        async register(user: User): Promise<void> {
            //  Split the full name into first and last
            const names = user.fullname.split(' ')

            //  Clone the user, this way we don't end up modifying the actual user
            const dupe = window._.cloneDeep(user)

            //  First name is the first index
            dupe.firstname = names.splice(0, 1)[0]

            //  Last name is every other index combined
            dupe.lastname = names.join(' ')

            // Get the user-inputted phone number
            let phone = dupe.mobilephone

            // Unmask the phone number
            phone = phone.replace(/\D/g, '')

            if (phone.length == 10) {
                // Append 1 to the phone number for North America
                phone = `1${phone}`

                // Update user with the correct number
                dupe.mobilephone = phone
            }

            // By clicking submit, they accept the terms
            dupe.terms_accepted = true

            //  Start our submitting
            this.submitting = true

            //  Register the user with the API
            const admin = await this.$store.dispatch('register', dupe)

            //  Stop our submitting
            this.submitting = false

            // Variable that will hold the previous link that the user was at before they were sent to the user registration page
            const linkCameFrom = this.$route.query.referrer || 'URL Not Found'

            // Construct object that will be sent to Segment
            const data = { website_url: linkCameFrom }

            //  Else, publish the user registered event
            events.onUserRegistered(admin, data)

            //  Route user to email verification, Include our reseller query IF it exists
            this.$router.push(`/register/verify${this.query || ''}`)
        }
    }
})
